import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { PhoneCheck } from 'src/app/config/constants';
import { CommonService } from 'src/app/lib/services/common.service';
import { UserService } from 'src/app/lib/services/user.service';
import { StorageService } from 'src/app/lib/services/storage.service';
import { Constants } from 'src/app/config/constants';
// import { Barcode, BarcodeScanner, BarcodeFormat } from '@capacitor-mlkit/barcode-scanning';
import { VoiceRecorderService } from 'src/app/lib/services/voice-recorder-permission.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-pos-login',
  templateUrl: './pos-login.component.html',
  styleUrls: ['./pos-login.component.scss'],
  standalone: false
})
export class PosLoginComponent implements OnInit {
  invalidPhone: boolean = true;
  phoneNumber: any = null;
  isButtonEnabled: boolean = false;
  isDisabled: boolean = false;
  form = {
    mobileNumber: '',
    firstName: '',
  };
  userData: any;
  showSuccessMessage: boolean;
  shopId: any;
  phone: any;
  returnUrl: any;
  resultContent: any;
  isSupported = false;
  guid: any;

  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    public commonService: CommonService,
    private userService: UserService,
    private storageservice: StorageService,
    private voiceRecorderService: VoiceRecorderService,
    private zone: NgZone,
  ) { }

  ngOnInit() {
    const { shopMeta: { shop: { guid } } } = this.commonService.getUserData();
    this.guid = guid;
    this.voiceRecorderService.requestAudioRecordingPermission();
  }

  ionViewWillEnter() {
    localStorage.removeItem(Constants.CART_DATA);
  }

  async startScanner() {
    this.commonService.toast('Feature will be available soon.');
  }

  async getPhoneNumber(uuid: string) {
    const loading = await this.commonService.presentLoader();
    loading.present();
    this.userService.getPhoneNumber(uuid).subscribe((number: any) => {
      if (number.success === true && number.data != null && number.data != undefined) {
        loading.dismiss();
        this.phoneNumber = number.data[0].phone;
      }
    }, (error: any) => {
      loading.dismiss();
      this.commonService.errorToast(error);
    });
  }

  async loginGuest() {
    this.phoneNumber = this.commonService.userData.phone;
  }

  isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  async validatePhone(e: any) {
    const invalidPhone = !PhoneCheck(this.phoneNumber);
    if (invalidPhone) {
      this.isButtonEnabled = false;
      return;
    }
    this.storageservice.setItem(Constants.POS_CUSTOMER_NUMBER, this.phoneNumber);
    const formData = { phone: this.phoneNumber, referredBy: this.guid };
    const loading = await this.commonService.presentLoader();
    loading.present();
    try {
      const data: any = await lastValueFrom(this.userService.validatePhone(formData));
      const { data: { isNumberRegistered, userName, userId, location } } = data;
      data.data.phone = this.phoneNumber;
      this.isButtonEnabled = true;
      this.addUserDetails(data.data);
      if (userId) {
        this.storageservice.setItem(Constants.POS_CUSTOMER_USERID, userId);
        this.storageservice.setItem(Constants.POS_CUSTOMER_LOCATION, location);
      }
    } catch (err) {
      this.isButtonEnabled = false;
      this.form.firstName = 'Guest';
      this.commonService.errorToast(err);
    } finally {
      loading.dismiss();
    }
  }


  async addUserDetails(data?: any) {
    this.modalCtrl.dismiss(data);
  }

  async startVoiceRecognition() {
    this.commonService.toast('Voice recognition will be available soon.');
    // try {
    //   // Ensure Web Speech API is supported
    //   const SpeechRecognition = (window as any).webkitSpeechRecognition || (window as any).SpeechRecognition;
    //   if (!SpeechRecognition) {
    //     this.commonService.danger('Web Speech API is not supported in this browser.');
    //     return;
    //   }

    //   const recognition = new SpeechRecognition();
    //   recognition.continuous = false;
    //   recognition.interimResults = false;
    //   recognition.lang = 'en-US';

    //   recognition.onstart = () => {
    //     console.log('Voice recognition started.');
    //   };

    //   recognition.onresult = (event: any) => {
    //     const transcript = event.results[0][0].transcript;
    //     const phoneNumber = transcript.replace(/\D/g, '');
    //     this.zone.run(() => {
    //       this.phoneNumber = phoneNumber;
    //     });
    //     this.validatePhone(null);
    //   };

    //   recognition.onerror = (event: any) => {
    //     console.error('Speech recognition error detected: ', event.error);
    //     this.commonService.danger('An error occurred during voice recognition: ' + event.error);
    //   };

    //   recognition.onend = () => {
    //     console.log('Voice recognition ended.');
    //   };

    //   recognition.start();
    // } catch (error) {
    //   console.error('An error occurred during voice recognition:', error);
    // }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  goBack() {
    this.router.navigate(['/home'])
  }
}
